import { render } from "./itManagement.vue?vue&type=template&id=01a42ad3"
import script from "./itManagement.vue?vue&type=script&lang=js"
export * from "./itManagement.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sec.daragroups.com/sec.daragroups.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__